import router from '@/router'
router.beforeEach(async (to, from, next) => {
    if (from.name == "UstomsInspection" && from.meta.cheaKIslogin) {
        next({
            path: "/UstomsInspection"
        })
    }
    next();
})